import Vue from 'vue';
import {handleErrors} from "@/services/ErrorHandling";

const self = Vue.prototype;

export default {

    getCombinedOrders(url, page = 1, perPage = 10) {
        return new Promise((resolve, reject) => {
            self.axios.get(self.$apiRouter.adminCombinedOrders + `?page=${page}&per_page=${perPage}&${url}`)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    removeGroup(id) {
        return new Promise((resolve, reject) => {
            self.axios.delete(self.$apiRouter.adminCombinedOrders + `/${id}`)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    getGroupOrders(id) {
        return new Promise((resolve, reject) => {
            self.axios.get(self.$apiRouter.adminCombinedOrdersGroup + `/${id}`)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    deleteOrderFromGroup(id) {
        return new Promise((resolve, reject) => {
            self.axios.delete(self.$apiRouter.adminCombinedOrdersOrder + `/${id}`)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    setLabelColors(groupId, color) {
        return new Promise((resolve, reject) => {
            self.axios.put(self.$apiRouter.adminCombinedOrdersLabelColor, { group_id: groupId, label_color: color })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    handleErrors(error, reject)
                })
        })
    },

    getOrdersForCombine(ids) {
        return new Promise((resolve, reject) => {
            self.axios.get(self.$apiRouter.adminCombinedOrdersForCombine + `?${ids}`)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    createGroup(ids) {
        return new Promise((resolve, reject) => {
            self.axios.post(self.$apiRouter.adminCombinedOrdersForCombine, { ids: ids })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    getGroup(id) {
        return new Promise((resolve, reject) => {
            self.axios.get(self.$apiRouter.adminCombinedOrders + `/${id}`)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    update(body) {
        return new Promise((resolve, reject) => {
            self.axios.put(self.$apiRouter.adminCombinedOrders, body)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    handleErrors(error, reject)
                })
        })
    },

}
